export const FLIP_CLOCK_SETTINGS = {
    bg_color_main: '#4d66acff',
    shadow_color: 'rgba(0, 0, 0, 0.7)',
    bg_color_sub: '#2e65ba',
    bg_color_flip: ' #487fd4',
    timeFormat: '24',
    clock_type: "FLIP",
    text_color: '#ececed',
}

export const CLOCK_TYPES = [
    { label: "Flip", value: "FLIP" },
    { label: "Analog", value: "ANALOG" },
    { label: "Digital", value: "DIGITAL" },
    { label: "Simple", value: "SIMPLE" },
]

export const CLOCK_FORMAT = [
    { label: "24", value: "24" },
    { label: "12", value: "12" },
]